import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';

export default class BackOfANapkinTemplatesUpsellComponent extends Component {
  @service organisation;

  calculateValue(customers = 0, upsell_value = 0) {
    return (+customers || 0) * (+upsell_value || 0);
  }

  get valueBeforeConfidence() {
    return this.calculateValue(
      this.args.calculation.customers,
      this.args.calculation.upsell_value,
    );
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  @action
  handleChange(e) {
    const calculation = { ...this.args.calculation };
    calculation[e.target.name] = Number(e.target.value);
    calculation.value = this.calculateValue(
      calculation.customers,
      calculation.upsell_value,
    );
    this.args.onValueEmit(calculation);
  }

  get confidenceLabel() {
    // if (this.args.calculation.confidence === undefined) return '-';
    // else return this.organisation.getReturnConfidenceLabel(this.args.calculation.confidence);
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      !isNullOrUndefined(this.args.calculation.customers) &&
      !isNullOrUndefined(this.args.calculation.upsell_value) &&
      !isNullOrUndefined(this.args.calculation.confidence_value)
    )
      return (
        this.valueBeforeConfidence * +this.args.calculation.confidence_value
      );
    else return '-';
  }

  get isDisabled() {
    return !this.args.editMode;
  }
}
